module.exports = __webpack_public_path__ + "img/logo-dark.0c7381c2.png";